<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px"
  *ngIf="!clientCardLoader && currCard$ &&currCard$.type=='card'">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <img src=" {{currCard$.card.logo_src}}" class="rad-bord logo-card"
      *ngIf="currCard$.card.brand !== 'visa' && currCard$.card.brand !== 'mastercard'">
    <img src="assets/img/refonte-logo/VISA.png" class="rad-bord h-10" *ngIf="currCard$.card.brand === 'visa'">
    <img src="assets/img/refonte-logo/MASTERCARD.png" class="rad-bord h-10" *ngIf="currCard$.card.brand === 'mastercard'">
    <span class="mat-subheading-1 boldest">{{currCard$.card.brand | capitalize}}</span>
  </div>
  <span class="mat-subheading-1" style="color:grey" fxHide.xs>**** **** **** {{currCard$.card.last4}}</span>
  <span class="mat-subheading-1" style="color:grey" fxHide fxShow.xs>**** {{currCard$.card.last4}}</span>
</div>


<div fxLayout="row" fxLayout="center center" fxLayoutGap="5px" *ngIf="!clientCardLoader && !currCard$ ">

  <!-- <span class="mat-subheading-1">{{"endorder.select-payment-card" | translate | capitalize}}</span> -->
  <span class="mat-subheading-1">{{"endorder.addPaymentMethodB"|translate}}</span>
</div>
<div fxLayoutAlign="center center">
  <mat-spinner diameter="20" *ngIf="clientCardLoader"></mat-spinner>
</div>
